// src/components/ViewReports.js

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchReportsByDate } from '../actions/reportActions';
import {
  Typography,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Alert,
  Box,
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const ViewReports = () => {
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [errorMessage, setErrorMessage] = useState('');
  const reports = useSelector((state) => state.reports.reportsByDate);

  useEffect(() => {
    const dateString = selectedDate.toISOString().split('T')[0];
    dispatch(fetchReportsByDate(dateString))
      .catch((error) => {
        setErrorMessage('Eroare la preluarea rapoartelor.');
        console.error(error);
      });
  }, [dispatch, selectedDate]);

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        Vizualizare Rapoarte
      </Typography>

      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          label="Selectează data"
          value={selectedDate}
          onChange={(newDate) => setSelectedDate(newDate)}
          renderInput={(params) => <TextField {...params} margin="normal" />}
        />
      </LocalizationProvider>

      {errorMessage && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errorMessage}
        </Alert>
      )}

      {reports && reports.length > 0 ? (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nume Copil</TableCell>
              <TableCell>Prezent</TableCell>
              <TableCell>Masa</TableCell>
              <TableCell>Comportament și Stare</TableCell>
              <TableCell>Vizite la WC</TableCell>
              <TableCell>Ore de Somn</TableCell>
              <TableCell>Observații de Sănătate</TableCell>
              <TableCell>Evenimente Speciale</TableCell>
              <TableCell>Zone de Îngrijorare</TableCell>
              <TableCell>Atenție Părinți</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reports.map((report) => (
              <TableRow key={report.report_id}>
                <TableCell>{report.child_name}</TableCell>
                <TableCell>{report.present ? 'Yes' : 'No'}</TableCell>
                <TableCell>{report.meal}</TableCell>
                <TableCell>{report.behaviour_mood}</TableCell>
                <TableCell>{report.wc_visits}</TableCell>
                <TableCell>{report.sleep_hours}</TableCell>
                <TableCell>{report.health_notes}</TableCell>
                <TableCell>{report.special_events}</TableCell>
                <TableCell>{report.areas_of_concern}</TableCell>
                <TableCell>{report.parent_attention}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        <Typography>Nu există rapoarte disponibile pentru această dată.</Typography>
      )}
    </div>
  );
};

export default ViewReports;
